module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/luis-3b7b67f61037c4ca15ccd65fbc2b418d.jpg";